import React, { useEffect, useRef, useState } from 'react';
import { api, PHASES } from './api';

// El log de una corrida, en vivo: pide cada 2 s lo que venga después del último `seq` mientras
// la corrida está viva. Con filtros (nivel, fase, texto) vuelve a pedir desde el principio.
const LogViewer = ({ id, live }) => {
    const [lines, setLines] = useState([]);
    const [level, setLevel] = useState("");
    const [phase, setPhase] = useState("");
    const [q, setQ] = useState("");
    const [follow, setFollow] = useState(true);
    const lastSeq = useRef(0);
    const box = useRef(null);
    const filters = { level, phase, q };

    const fetchMore = (reset) => {
        const after = reset ? 0 : lastSeq.current;
        return api.logs(id, { ...filters, after }).then((r) => {
            if (!r.ok) return;
            const nuevos = r.logs || [];
            if (nuevos.length) lastSeq.current = nuevos[nuevos.length - 1].seq;
            setLines((prev) => (reset ? nuevos : prev.concat(nuevos)));
        });
    };

    useEffect(() => {
        lastSeq.current = 0;
        setLines([]);
        const t0 = setTimeout(() => fetchMore(true), q ? 300 : 0);
        return () => clearTimeout(t0);
    }, [id, level, phase, q]);

    useEffect(() => {
        if (!live) return undefined;
        const t = setInterval(() => fetchMore(false), 2000);
        return () => clearInterval(t);
    }, [id, live, level, phase, q]);

    useEffect(() => {
        if (follow && box.current) box.current.scrollTop = box.current.scrollHeight;
    }, [lines, follow]);

    return (
        <div>
            <div className="sd-log-filters">
                <select className="rk-input" value={level} onChange={(e) => setLevel(e.target.value)}>
                    <option value="">Todos los niveles</option>
                    <option value="info">Info</option>
                    <option value="aviso">Avisos</option>
                    <option value="error">Errores</option>
                </select>
                <select className="rk-input" value={phase} onChange={(e) => setPhase(e.target.value)}>
                    <option value="">Todas las fases</option>
                    {PHASES.concat([{ key: "deshacer", label: "Deshacer" }]).map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
                </select>
                <input className="rk-input" placeholder="Buscar en el log…" value={q} onChange={(e) => setQ(e.target.value)} />
                <label className="sd-switch"><input type="checkbox" checked={follow} onChange={(e) => setFollow(e.target.checked)} /> Seguir el final</label>
                <span style={{ marginLeft: "auto" }} className="sd-muted">{lines.length} línea(s)</span>
                <a className="rk-btn rk-btn--ghost" href={api.downloadUrl(id, "txt", filters)}><i className="fas fa-download"></i> .txt</a>
                <a className="rk-btn rk-btn--ghost" href={api.downloadUrl(id, "json", filters)}><i className="fas fa-download"></i> .json</a>
            </div>
            <div className="sd-log" ref={box}>
                {lines.length === 0 && <div className="sd-log__empty">{live ? "Esperando las primeras líneas…" : "Sin líneas con estos filtros."}</div>}
                {lines.map((l) => (
                    <div key={l.seq} className={`sd-log__line sd-log__line--${l.level}`}>
                        <span className="sd-log__seq">{l.seq}</span>
                        <span className="sd-log__phase">[{l.phase}]</span>
                        <span className="sd-log__msg">{l.level === "error" ? "✗ " : l.level === "aviso" ? "! " : ""}{l.message}</span>
                        {l.duration_ms !== null && l.duration_ms !== undefined && <span className="sd-log__ms">{l.duration_ms} ms</span>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LogViewer;
